import React from 'react';

function PhoneIcon({ className = '' }) {
	return (
		<svg
			width='28'
			height='28'
			viewBox='0 0 28 28'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M7.72333 12.5883C9.40333 15.89 12.11 18.585 15.4117 20.2767L17.9783 17.71C18.2933 17.395 18.76 17.29 19.1683 17.43C20.475 17.8617 21.8867 18.095 23.3333 18.095C23.975 18.095 24.5 18.62 24.5 19.2617V23.3333C24.5 23.975 23.975 24.5 23.3333 24.5C12.3783 24.5 3.5 15.6217 3.5 4.66667C3.5 4.025 4.025 3.5 4.66667 3.5H8.75C9.39167 3.5 9.91667 4.025 9.91667 4.66667C9.91667 6.125 10.15 7.525 10.5817 8.83167C10.71 9.24 10.6167 9.695 10.29 10.0217L7.72333 12.5883Z'
				fill='white'
			/>
		</svg>
	);
}

export default PhoneIcon;
